









































import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import TypedGeneralFormFields from "~/components/global/TypedGeneralFormFields";
import GoogleRecaptchaV2 from "~/components/global/GoogleRecaptchaV2";
import { FormDescription } from "~/workera/utils/typedForms/shared/form/FormDescription";
import { getModule } from "vuex-module-decorators";

import {
  InputField,
  RadioField,
  FormFieldType
} from "~/workera/utils/typedForms/shared/form/FormField";

import { EmailValidator } from "~/workera/utils/typedForms/validators/string/EmailValidator";
import { PasswordValidator } from "~/workera/utils/typedForms/validators/string/PasswordValidator";
import { EmptyValidator } from "~/workera/utils/typedForms/validators/string/EmptyValidator";
import { VisaValidator } from "~/workera/utils/typedForms/validators/string/VisaValidator";
import { None, Some } from "space-lift";
import { PasswordField } from "~/workera/utils/typedForms/shared/form/FormField";
import { utils } from "~/workera/utils/serviceUtils";

@Component({
  layout: "public",
  components: {
    TypedGeneralFormFields,
    GoogleRecaptchaV2
  },
  head() {
    return {
      title: "Workera | AI Career Pathways Report",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "AI Career Pathways Report. Companies everywhere are building AI teams, but it’s still unclear what aspiring MLEs should focus on when applying for ML jobs"
        }
      ]
    };
  }
})
export default class report extends Vue {
  private formDescription: FormDescription;

  selectedInfo = {
    firstName: "",
    lastName: "",
    email: "",
    companyName: ""
  };
  editable = true;
  recaptchaKey = "";

  constructor() {
    super();

    const roleOptions = [
      "Data Analyst",
      "Data Scientist",
      "Machine Learning Engineer",
      "Machine Learning Researcher",
      "Software Engineer - Machine Learning",
      "Software Engineer",
      "Other (product manager, marketer, recruiter, business leader, etc.)"
    ];

    this.formDescription = new FormDescription([
      new InputField(
        "firstName",
        "First name",
        true,
        "Enter your first name",
        [new EmptyValidator("")],
        []
      ),
      new InputField(
        "lastName",
        "Last name",
        true,
        "Enter your last name",
        [new EmptyValidator("")],
        []
      ),
      new InputField(
        "email",
        "Email",
        true,
        "Enter your email address",
        [new EmptyValidator(""), new EmailValidator()],
        []
      ),
      new RadioField(
        "role",
        "What role of an AI team do you identify as?",
        [new EmptyValidator("")],
        [],
        true,
        roleOptions,
        true
      )
    ]);
  }

  setRecaptchaKey(key: string) {
    this.recaptchaKey = key;
  }

  onSubmit() {
    this.$analytics.track("Report form Completed", this.selectedInfo);
    utils
      .postJsonToUrl(
        process.env.baseUrl + "/public/report",
        { ...this.selectedInfo, recaptchaKey: this.recaptchaKey },
        ""
      )
      .then(_ => {
        this.$router.push("/redirect/ai_career_pathways");
      })
      .catch(error => {
        console.error(error);
      });
  }
}
